export default __webpack_public_path__ + "static/media/close-icon.ba00133e.svg";